import React from "react";
import "./Footer.css";
import { Fade } from "react-reveal";
/* eslint-disable jsx-a11y/accessible-emoji */

export default function Footer() {
  return (
    <></>
    // <div className="footer-div" style={{ textAlignLast: "center" }}>
    //   <Fade>
    //     <p className="footer-text">
    //       Made by{" "}
    //       <a
    //         href="https://github.com/RohanShah27/"
    //         target="_blank"
    //         style={{ textDecoration: "underline", color: "#868e96" }}
    //       >
    //         Rohan Shah
    //       </a>{" "}
    //       &lt;/&gt;{" "}
    //     </p>
    //   </Fade>
    // </div>
  );
}
